define('gumbo-js-client-lib/forms/gameData/TeamForm',{
	division: null,
	fileCode: null,
	leagueID: null,
	sportcode: null,
	teamID: null,
	team: null,
	divisionID: null,
	league: null,
	name: {
		abbrev: null,
		display: null,
		full: null,
		brief: null,
		city: null
	},
	record: {
		win: null,
		loss: null,
		gamesBack: null,
		gamesBackWildcard: null
	}
});
